module.exports = __webpack_public_path__ + "static/media/12.022.4b3f5374.jpg";